import app from "js/legacy-app";

app.service('NegotiationComment', ['$resource', function ($resource) {
    return $resource('/api/negotiation-comment', {}, {});
}]);
